import {
  OverridableQuery,
  UseQueryOptions,
  restrictApi,
  useQuery,
} from '@wyz/utils';
import { useApi } from '~/common/context';
import { IVehicleTypeGroupList } from '~/common/types';
import { ConnectQueryKeys } from '~/connect/api';

type Options = {
  coreVehicleTypeGroup?: OverridableQuery<
    UseQueryOptions<IVehicleTypeGroupList>
  >;
};
export const useManageVehicleTypeGroups = <
  TRequestedKeys extends keyof Options,
  TRequestedOptions extends Options = Pick<Options, TRequestedKeys>,
>(
  options: TRequestedOptions,
) => {
  const { callCoreApi } = useApi();
  const coreVehicleTypeGroupQuery = useQuery({
    queryKey: ConnectQueryKeys.vehicleTypeGroups.core(),
    queryFn: () =>
      callCoreApi<IVehicleTypeGroupList>(
        '/settings/api/vehicle-type-groups',
        {},
      ),
    enabled: false,
    ...options.coreVehicleTypeGroup,
  });

  return restrictApi(options, {
    coreVehicleTypeGroup: coreVehicleTypeGroupQuery,
  });
};
